import { BoardRevisionDiff, LayerDiff } from "../../../reducers/uploadedBoard";
import CannotProcessDiff from "./CannoProcessDiff";
import React from "react";
import ImageSetPreview from "../../common/ImageSetPreview";
import OffsetDetails from "./OffsetDetails";
import { PhysicalDetailsDiffDetails } from "./RevisionsStyles";

function DiffStatus({ layer }: { layer: LayerDiff }) {
  return (
    <PhysicalDetailsDiffDetails>{layer.diff_status}</PhysicalDetailsDiffDetails>
  );
}

export default function PhysicalDetails({
  diff,
}: {
  diff: BoardRevisionDiff | null;
}) {
  if (diff === null) {
    return <CannotProcessDiff />;
  }

  return (
    <>
      <OffsetDetails offset={diff.previous_board_offset} />
      <ImageSetPreview
        previewInfo={diff.physical_details.layers.map((layer) => {
          return {
            title: `${layer.name} Diff`,
            details: <DiffStatus layer={layer} />,
            previewUrl: layer.diff_image.detail as string,
            svgUrl: layer.diff_image.svg,
          };
        })}
      />
    </>
  );
}
